import { convertDateToJobCountUpdateDate } from '@doda/common/src/utils/dateUtil';
import { PageTitle } from '@doda/io-react/pc';
import styles from './index.module.scss';

/**
 * NewJobListHeaderコンポーネントのプロパティ
 */
interface Props {
  /** 求人件数の更新日 */
  jobCountUpdateDate: string;
  /** 求人数 */
  jobCount: number;
}

/**
 * 新着求人一覧画面の画面上部コンポーネント
 *
 * @param {Props} props - NewJobListHeaderのプロパティ
 * @returns {JSX.Element} 新着求人一覧画面 画面上部のJSX要素
 */
export const NewJobListHeader: React.FC<Props> = ({
  jobCountUpdateDate,
  jobCount,
}) => {
  return (
    <div className={styles.newJobListHeader}>
      <div className={styles.newJobList__pageTitle}>
        <PageTitle>今週の新着・更新求人</PageTitle>
      </div>
      <div className={styles.jobCountInfo}>
        {convertDateToJobCountUpdateDate(jobCountUpdateDate)}
        （月曜・木曜更新）
        <span className={styles.jobCountNumber}>
          {jobCount.toLocaleString()}
        </span>
        &nbsp;件
      </div>
    </div>
  );
};
